<template lang="pug">
div(class="fixed w-full lg:hidden" style="z-index:100;" v-show="loading || firstLoad")
    div(class="progress-line")
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            firstLoad: true,
            timer: null,
        }
    },
    mounted() {
        this.firstLoad = false
    },
    methods: {
        start() {
            // on route changes, let it load for 1s before showing a loading bar
            this.timer = setTimeout(() => {
                this.loading = true
            }, 1000)
        },
        finish() {
            clearTimeout(this.timer)
            this.loading = false
        },
    },
}
</script>

<style lang="stylus" scoped>
.progress-line
.progress-line:before
    height 4px
    width 100%
    margin 0

.progress-line
    background-color #000
    display flex

.progress-line:before
    background-color theme('colors.primary.DEFAULT')
    content ''
    animation running-progress 2s cubic-bezier(0.4, 0, 0.2, 1) infinite

@keyframes running-progress
    0%
        margin-left 0px
        margin-right 100%
    50%
        margin-left 25%
        margin-right 0%
    100%
        margin-left 100%
        margin-right 0
</style>
